
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.6 18.612A2.481 2.481 0 005.09 21.1h6.862c1.379 0 2.509-1.107 2.509-2.488v-1.82a.969.969 0 10-1.939 0v1.82c0 .31-.253.55-.57.55H5.09a.538.538 0 01-.55-.55V5.388c0-.312.237-.549.55-.549h6.862c.317 0 .57.24.57.55v1.784a.969.969 0 101.939 0V5.388c0-1.38-1.13-2.488-2.509-2.488H5.09A2.481 2.481 0 002.6 5.388v13.224z","fill":"#5F6271"}}),_c('path',{attrs:{"d":"M16.299 16.631c.177.14.39.21.598.21a.953.953 0 00.731-.337l3.289-3.79A.972.972 0 0021.23 12a.955.955 0 00-.366-.755l-3.288-3.289a.97.97 0 00-1.37 0 .97.97 0 000 1.369l1.707 1.706H7.74a.969.969 0 100 1.939h10.39l-1.964 2.263a.968.968 0 00.097 1.369l.035.03z","fill":"#5F6271"}})])
          )
        }
      }
    